import React from 'react';
import PropTypes from 'prop-types';
import * as Style from './style';

const Modal = ({
    openAction, isOpen, borderRadius, contentWidth, children,
}) => {
    const action = (event) => {
        if (event === 'modal') {
            openAction(false);
        }
    };

    return (
	<>
		{isOpen && (
		<Style.Overlay id="modal" onClick={e => action(e.target.id)}>
			<Style.Content width={contentWidth} borderradius={borderRadius}>
				{children}
			</Style.Content>
		</Style.Overlay>
            )}
	</>
    );
};

Modal.defaultProps = {
    borderRadius: 0,
};

PropTypes.Modal = {
    openAction: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    borderRadius: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    contentWidth: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    children: PropTypes.any.isRequired,
};

export default Modal;
